import * as React from 'react';
import { CredentialSchema } from '../../../../types';
import { STATIC_SRC } from '../../../../constants';

type Props = {
  schema: CredentialSchema;
};

export const ColumnSchemaIcon: React.FunctionComponent<Props> = ({
  schema,
}) => {
  const image = schema.image;
  const imageSrc = `${STATIC_SRC}${image}`;
  return <img src={imageSrc} alt={image} />;
};
